import { Routes } from '@angular/router';
import { HomeComponent } from './components/pages/home/home.component';
import { JobsComponent } from './components/pages/jobs/jobs.component';
import { FaqsComponent } from './components/pages/faqs/faqs.component';
import { ContactComponent } from './components/pages/contact/contact.component';
import { JobDetailsComponent } from './components/pages/job-details/job-details.component';
import { HowWorkComponent } from './components/pages/how-work/how-work.component';
import { PrivacyComponent } from './components/pages/privacy/privacy.component';
import { UserComponent } from './components/user/user.component';
import { AboutComponent } from './components/about/about.component';
import { AdminComponent } from './components/admin/admin.component';
import { DashboardComponent } from './components/admin/components/dashboard/dashboard.component';
import { JobListComponent } from './components/admin/components/job-list/job-list.component';
import { UserListComponent } from './components/admin/components/user-list/user-list.component';
import { NotificationsComponent } from './components/admin/components/notifications/notifications.component';
import { MessagesComponent } from './components/admin/components/messages/messages.component';
import { ProfileComponent } from './components/admin/components/profile/profile.component';
import { SettingsComponent } from './components/admin/components/settings/settings.component';
import { UserProfileComponent } from './components/pages/user-profile/user-profile.component';
import { NotfoundComponent } from './components/notfound/notfound.component';
import { ApplicationComponent } from './components/pages/application/application.component';
import { ApplicationsComponent } from './components/admin/components/applications/applications.component';
import { ArticleDetailsComponent } from './components/pages/article-details/article-details.component';
import { ArticleComponent } from './components/pages/article/article.component';
import { ArticlesComponent } from './components/admin/components/articles/articles.component';
import { ApplicationDetailsComponent } from './components/admin/components/application-details/application-details.component';
import { UserDetailsComponent } from './components/admin/components/user-details/user-details.component';
import { TestimonialComponent } from './components/admin/components/testimonial/testimonial.component';
import { CoursesComponent } from './components/pages/courses/courses.component';
import { CourseApplyComponent } from './components/pages/course-apply/course-apply.component';
import { CourseDashboardComponent } from './components/admin/components/course-dashboard/course-dashboard.component';

export const routes: Routes = [
   {
       path: "", 
       component: UserComponent,
       children: [
           { path: "", component: HomeComponent }, 
           { path: "Home", component: HomeComponent }, 
           { path: "About", component: AboutComponent },
           { path: "WhowItWork", component: HowWorkComponent },
           { path: "Jobs", component: JobsComponent },
           { path: "Jobs/:category", component: JobsComponent },
           { path: "job-details/:id", component: JobDetailsComponent },
           { path: "application/:jobId", component: ApplicationComponent },
           { path: "Articles", component: ArticleComponent },

           { path: "Article/:id", component: ArticleDetailsComponent },

           { path: "Courses", component: CoursesComponent },
           { path: "CourseApply/:level", component: CourseApplyComponent },
           { path: "Faqs", component: FaqsComponent },
           { path: "Contact", component: ContactComponent },
           { path: "Privacy", component: PrivacyComponent },
           { path: "Profile", component: UserProfileComponent },
       ]
   },
   {
       path: "Admin",
       component: AdminComponent,
       children: [
           { path: "", component: DashboardComponent }, // Keep only one
           { path: "Dashboard", component: DashboardComponent }, // Keep only one
           { path: "JobList", component: JobListComponent },
           { path: "UserList", component: UserListComponent },
           { path: "UserDetails/:id", component: UserDetailsComponent },
           { path: "Applications", component: ApplicationsComponent },
           { path: "ApplicationDetails/:id", component: ApplicationDetailsComponent },
           { path: "Courses", component: CourseDashboardComponent },
           { path: "Articles", component: ArticlesComponent },
           { path: "Testimonial", component: TestimonialComponent },
           { path: "Faqs", component: FaqsComponent },
           { path: "Notifications", component: NotificationsComponent },
           { path: "Messages", component: MessagesComponent },
           { path: "Profile", component: ProfileComponent },
           { path: "Settings", component: SettingsComponent },
       ]
   },
   { path: "**", component: NotfoundComponent }
];
